const headerTypeScopes = {
    sim: {
        spacecraft: true,
        //
        setup: true,
        loop: true
    }
};
export default headerTypeScopes;